"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _message = _interopRequireDefault(require("ant-design-vue/lib/message"));

require("ant-design-vue/lib/message/style/index.css");

var _lodash = _interopRequireDefault(require("lodash"));

var _vue = require("vue");

var _keyboard = require("../config/keyboard");

var _default = function _default(sheetMusicBusiness, ctx, cursorItem, keyBoardDisabeld, keyboardObj) {
  var _ref;

  var currentSelectType = (0, _vue.computed)(function () {
    return sheetMusicBusiness.value.editor.selectType;
  });
  var currentItem = (0, _vue.computed)(function () {
    return cursorItem.value;
  });
  var hideMessage = null;
  var unWatch = null;
  var selecting = (0, _vue.ref)(false);
  var selectingType = (0, _vue.ref)('');
  var begin_note, end_note, beforeSelectType;

  var closeSelect = function closeSelect() {
    if (selecting.value) {
      selecting.value = false;
    }

    if (hideMessage) {
      hideMessage();
      hideMessage = null;
    }

    if (unWatch) {
      unWatch();
      unWatch = null;
    }

    if (keyboardObj) {
      _lodash.default.flatMapDeep(keyboardObj).forEach(function (item) {
        if (item.originClass) {
          item.class = item.originClass;
        }

        if (item.originText) {
          item.text = item.originText;
        }
      });
    }

    if (selectingType.value) {
      selectingType.value = '';
    }

    if (beforeSelectType) {
      beforeSelectType = undefined;
    }
  };

  (0, _vue.watch)(function () {
    return keyBoardDisabeld.value;
  }, function (newVal) {
    newVal && closeSelect();
  });
  (0, _vue.onBeforeUnmount)(function () {
    closeSelect();
  });
  return _ref = {}, (0, _defineProperty2.default)(_ref, _keyboard.keybordActions.insertNote, function (params) {
    return new Promise(function (resolve) {
      var _a;

      if (sheetMusicBusiness.value) {
        if (!currentItem.value || !((_a = currentItem.value) === null || _a === void 0 ? void 0 : _a.sheetItem) || selecting.value) {
          resolve();
          return;
        }

        sheetMusicBusiness.value.insertNote(params);
        resolve();
      }
    });
  }), (0, _defineProperty2.default)(_ref, _keyboard.keybordActions.setNotePitch, function (params) {
    return new Promise(function (resolve) {
      if (sheetMusicBusiness.value && !selecting.value) {
        sheetMusicBusiness.value.setNotePitch(params.type);
        resolve();
      }
    });
  }), (0, _defineProperty2.default)(_ref, _keyboard.keybordActions.setNoteTick, function (params) {
    return new Promise(function (resolve) {
      if (sheetMusicBusiness.value && !selecting.value) {
        sheetMusicBusiness.value.setNoteTick(params.type);
        resolve();
      }
    });
  }), (0, _defineProperty2.default)(_ref, _keyboard.keybordActions.setNoteSemitone, function (params) {
    return new Promise(function (resolve) {
      if (sheetMusicBusiness.value && !selecting.value) {
        sheetMusicBusiness.value.setNoteSemitone(params);
        resolve();
      }
    });
  }), (0, _defineProperty2.default)(_ref, _keyboard.keybordActions.setNoteDots, function () {
    return new Promise(function (resolve) {
      if (sheetMusicBusiness.value && !selecting.value) {
        sheetMusicBusiness.value.setNoteDots();
        resolve();
      }
    });
  }), (0, _defineProperty2.default)(_ref, _keyboard.keybordActions.setNoteSlur, function (params) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    var keyboard = this;

    if (!keyboard.originText) {
      keyboard.originText = keyboard.text;
    }

    if (!keyboard.originClass) {
      keyboard.originClass = keyboard.class;
    }

    var type = params.type,
        selectType = params.selectType,
        message = params.message; // message

    if (selectingType.value && selectingType.value !== type) {
      _message.default.info('请先取消当前操作状态', 1.5);

      return Promise.resolve();
    }

    return new Promise(function (resolve) {
      if (!sheetMusicBusiness.value) {
        return;
      }

      var handleBegin = function handleBegin() {
        keyboard.class = 'action-btn-green small-text';
        selecting.value = true;
        selectingType.value = type;
        beforeSelectType = currentSelectType.value;
        sheetMusicBusiness.value.changeSelectType(selectType, true);
        hideMessage = _message.default.info(message, 0);
      };

      var handleEnd = function handleEnd() {
        unWatch && unWatch();
        selecting.value = false;
        selectingType.value = '';
        keyboard.text = keyboard.originText;
        keyboard.class = keyboard.originClass;
        sheetMusicBusiness.value.changeSelectType(beforeSelectType);

        if (begin_note && end_note) {
          sheetMusicBusiness.value.setNoteSlur({
            type: type,
            begin: begin_note,
            end: end_note
          });
        }

        begin_note = undefined;
        end_note = undefined;
        hideMessage && hideMessage() && (hideMessage = null);
        resolve();
      };

      var handPointClick = function handPointClick() {
        if (!selecting.value) {
          return;
        }

        if (!begin_note) {
          begin_note = (0, _vue.toRaw)(currentItem.value.sheetItem);
          return;
        }

        var _end = (0, _vue.toRaw)(currentItem.value.sheetItem);

        if (begin_note.getId() == _end.getId()) {
          return;
        }

        end_note = _end;
        handleEnd();
      };

      if (!selecting.value) {
        unWatch = (0, _vue.watch)(function () {
          return currentItem.value;
        }, function (newVal) {
          if (!newVal || !(newVal === null || newVal === void 0 ? void 0 : newVal.sheetItem) || (newVal === null || newVal === void 0 ? void 0 : newVal.itemType) !== 'NOTE') {
            return;
          }

          handPointClick();
        });
        handleBegin();
      } else {
        handleEnd();
      }
    });
  }), (0, _defineProperty2.default)(_ref, _keyboard.keybordActions.remove, function () {
    return new Promise(function (resolve) {
      if (sheetMusicBusiness.value && !selecting.value) {
        console.log('删除', currentItem.value.itemType);

        if (currentItem.value.itemType === 'MEASURE') {
          _message.default.info('不能删除小节', 1.5);
        } else if (currentItem.value.itemType === 'PART') {
          _message.default.info('不能删除整行', 1.5);
        } else {
          sheetMusicBusiness.value.remove(false);
        }

        resolve();
      }
    });
  }), (0, _defineProperty2.default)(_ref, _keyboard.keybordActions.undo, function () {
    return new Promise(function (resolve) {
      if (sheetMusicBusiness.value) {
        if (selecting.value) {
          closeSelect();
          resolve();
          return;
        }

        sheetMusicBusiness.value.undo();
        resolve();
      }
    });
  }), (0, _defineProperty2.default)(_ref, _keyboard.keybordActions.redo, function () {
    return new Promise(function (resolve) {
      if (sheetMusicBusiness.value) {
        if (selecting.value) {
          closeSelect();
          resolve();
          return;
        }

        sheetMusicBusiness.value.redo();
        resolve();
      }
    });
  }), (0, _defineProperty2.default)(_ref, _keyboard.keybordActions.reset, function () {
    return new Promise(function (resolve) {
      closeSelect();
      ctx.emit('restConfirm');
      resolve();
    });
  }), (0, _defineProperty2.default)(_ref, _keyboard.keybordActions.piano, function () {
    return new Promise(function (resolve) {
      if (sheetMusicBusiness.value) {
        resolve();
      }
    });
  }), (0, _defineProperty2.default)(_ref, _keyboard.keybordActions.dore, function () {
    return new Promise(function (resolve) {
      if (sheetMusicBusiness.value) {
        resolve();
      }
    });
  }), (0, _defineProperty2.default)(_ref, _keyboard.keybordActions.play, function () {
    return new Promise(function (resolve) {
      if (sheetMusicBusiness.value) {
        console.log('play');
        resolve();
      }
    });
  }), _ref;
};

exports.default = _default;